module.exports = __webpack_public_path__ + "img/cardImg.1a790fc8.png";